export default __webpack_public_path__ + "static/1-ab989b02fb6551f994fa9d31d57ac756.webp";